import React, { useEffect, useRef } from "react";

// Chauwk Website Agent - runs on our Exotel voice server (Agent-Stream-Voice-Agent).
// Embed code generated by the voice server's API:
//   GET https://ai.chauwk.com/api/exotel-sip/agents/agent_4ace24837952/embed-link
//   <agent-stream-voice agent-id="agent_4ace24837952" server-url="https://ai.chauwk.com"></agent-stream-voice>
//   <script src="https://ai.chauwk.com/static/voice-agent-widget.js" async></script>
// The widget shows itself as a floating button and loads the agent's name from the server.
export const WEBSITE_AGENT_ID = "agent_4ace24837952";
const SERVER_URL = "https://ai.chauwk.com";
const SCRIPT_SRC = `${SERVER_URL}/static/voice-agent-widget.js`;

const loadWidgetScript = () => {
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
  const script = document.createElement("script");
  script.src = SCRIPT_SRC;
  script.async = true;
  script.onerror = () => console.error("Failed to load the Chauwk voice agent widget");
  document.body.appendChild(script);
};

const LAUNCHER_LABEL = "Speak to Zara";

// The widget renders a round mic button inside an open shadow root; restyle it
// into a "Speak to Zara" pill without touching the server-hosted script.
const LAUNCHER_STYLES = `
  .launcher-btn {
    width: auto;
    height: 56px;
    padding: 0 28px 0 22px;
    gap: 12px;
    border-radius: 999px;
    background: linear-gradient(135deg, #1a73e8 0%, #0b4fc4 100%);
    border: none;
    box-shadow: 0 10px 30px rgba(26, 115, 232, 0.45);
    font-family: inherit;
  }
  .launcher-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 36px rgba(26, 115, 232, 0.6);
  }
  .launcher-btn svg {
    width: 24px;
    height: 24px;
  }
  .launcher-btn .pulse-ring {
    display: none;
  }
  .launcher-label {
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 0.2px;
    white-space: nowrap;
  }
  @media (max-width: 480px) {
    .launcher-btn {
      height: 50px;
      padding: 0 20px 0 16px;
      gap: 10px;
    }
    .launcher-label {
      font-size: 15px;
    }
  }
`;

const styleLauncher = (widget) => {
  const shadow = widget && widget.shadowRoot;
  const launcher = shadow && shadow.getElementById("launcher-btn");
  if (!launcher || launcher.querySelector(".launcher-label")) return;

  const style = document.createElement("style");
  style.textContent = LAUNCHER_STYLES;
  shadow.appendChild(style);

  const label = document.createElement("span");
  label.className = "launcher-label";
  label.textContent = LAUNCHER_LABEL;
  launcher.appendChild(label);
  launcher.title = LAUNCHER_LABEL;
};

const ExotelVoiceWidget = ({ agentId = WEBSITE_AGENT_ID, autoOpen = false }) => {
  const widgetRef = useRef(null);

  useEffect(() => {
    loadWidgetScript();

    let observer;
    let cancelled = false;
    customElements.whenDefined("agent-stream-voice").then(() => {
      const widget = widgetRef.current;
      if (cancelled || !widget || !widget.shadowRoot) return;
      styleLauncher(widget);
      // Re-apply if the widget re-renders its shadow root
      observer = new MutationObserver(() => styleLauncher(widget));
      observer.observe(widget.shadowRoot, { childList: true });
    });

    return () => {
      cancelled = true;
      if (observer) observer.disconnect();
    };
  }, []);

  return autoOpen ? (
    <agent-stream-voice ref={widgetRef} agent-id={agentId} server-url={SERVER_URL} auto-open="true"></agent-stream-voice>
  ) : (
    <agent-stream-voice ref={widgetRef} agent-id={agentId} server-url={SERVER_URL}></agent-stream-voice>
  );
};

export default ExotelVoiceWidget;
